namespace Matrix.Rebalancer {
    export interface ModellingViewFormatRow {
        ColumnSetCode?: string;
        SortOrder?: number;
        Expression?: string;
        FieldName?: string;
        BackColour?: string;
        ForeColour?: string;
        FontSize?: number;
        FontBold?: boolean;
        FontItalic?: boolean;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        ColumnSetName?: string;
        ColumnSetCodeRowId?: number;
    }

    export namespace ModellingViewFormatRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'ColumnSetCode';
        export const localTextPrefix = 'Rebalancer.ModellingViewFormat';
        export const deletePermission = 'DataAdmin:Rebalancer';
        export const insertPermission = 'DataAdmin:Rebalancer';
        export const readPermission = 'Read:Rebalancer';
        export const updatePermission = 'DataAdmin:Rebalancer';

        export declare const enum Fields {
            ColumnSetCode = "ColumnSetCode",
            SortOrder = "SortOrder",
            Expression = "Expression",
            FieldName = "FieldName",
            BackColour = "BackColour",
            ForeColour = "ForeColour",
            FontSize = "FontSize",
            FontBold = "FontBold",
            FontItalic = "FontItalic",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            ColumnSetName = "ColumnSetName",
            ColumnSetCodeRowId = "ColumnSetCodeRowId"
        }
    }
}
